import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.14715 5.20117C3.86531 5.20117 2.82617 6.24031 2.82617 7.52215V18.3534C2.82617 19.6352 3.86531 20.6744 5.14715 20.6744H20.6204C21.9022 20.6744 22.9413 19.6352 22.9413 18.3534V7.52215C22.9413 6.24031 21.9022 5.20117 20.6204 5.20117H5.14715ZM21.394 6.74849H4.37349V19.1271H21.394V6.74849Z",
			fill: "#360802"
		}), /* @__PURE__ */ _jsx("rect", {
			x: 2.82422,
			y: 9.06934,
			width: 20.1152,
			height: 3.09464,
			fill: "#360802"
		})]
	})
});
export default SvgCreditCard;
